// import * as React from "react"
// import {
//   AlertDialog,
//   AlertDialogAction,
//   AlertDialogCancel,
//   AlertDialogContent,
//   AlertDialogDescription,
//   AlertDialogFooter,
//   AlertDialogHeader,
//   AlertDialogTitle,
// } from "../components/ui/AlertDialog"

// interface ConfirmationDialogProps {
//   open: boolean
//   onOpenChange: (open: boolean) => void
//   onConfirm: () => void
//   title?: string
//   description?: string
//   confirmLabel?: string
//   cancelLabel?: string
//   disabled?: boolean
// }

// const ConfirmationDialog: React.FC<ConfirmationDialogProps> = ({
//   open,
//   onOpenChange,
//   onConfirm,
//   title = "Are you sure?",
//   description = "This action cannot be undone.",
//   confirmLabel = "Continue",
//   cancelLabel = "Cancel",
//   disabled = false
// }) => {
//   const handleConfirm = (e: React.MouseEvent<HTMLButtonElement>) => {
//     e.preventDefault();
//     onConfirm();
//   };

//   return (
//     <AlertDialog open={open} onOpenChange={onOpenChange}>
//       <AlertDialogContent>
//         <AlertDialogHeader>
//           <AlertDialogTitle>{title}</AlertDialogTitle>
//           <AlertDialogDescription>{description}</AlertDialogDescription>
//         </AlertDialogHeader>
//         <AlertDialogFooter>
//           <AlertDialogCancel>{cancelLabel}</AlertDialogCancel>
//           <AlertDialogAction 
//             onClick={handleConfirm}
//             disabled={disabled}
//             className="bg-destructive text-destructive-foreground hover:bg-destructive/90"
//           >
//             {confirmLabel}
//           </AlertDialogAction>
//         </AlertDialogFooter>
//       </AlertDialogContent>
//     </AlertDialog>
//   )
// }

// export { ConfirmationDialog }
// export type { ConfirmationDialogProps }

import * as React from "react"
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "./ui/AlertDialog"
import { Input } from "./ui/Input"

interface ConfirmationDialogProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  onConfirm: () => void
  title?: string
  description?: string
  confirmLabel?: string
  cancelLabel?: string
  disabled?: boolean
  requireVerification?: boolean
  verificationWord?: string
}

const ConfirmationDialog: React.FC<ConfirmationDialogProps> = ({
  open,
  onOpenChange,
  onConfirm,
  title = "Are you sure?",
  description = "This action cannot be undone.",
  confirmLabel = "Continue",
  cancelLabel = "Cancel",
  disabled = false,
  requireVerification = false,
  verificationWord = "DELETE"
}) => {
  const [verificationInput, setVerificationInput] = React.useState("");
  
  const handleConfirm = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    if (!requireVerification || verificationInput === verificationWord) {
      onConfirm();
    }
  };

  const isConfirmDisabled = disabled || (requireVerification && verificationInput !== verificationWord);

  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>{title}</AlertDialogTitle>
          <AlertDialogDescription className="space-y-4">
            <p>{description}</p>
            {requireVerification && (
              <div className="space-y-2">
                <p className="text-sm">Please type <strong>{verificationWord}</strong> to confirm</p>
                <Input
                  type="text"
                  value={verificationInput}
                  onChange={(e) => setVerificationInput(e.target.value)}
                  placeholder={`Type ${verificationWord} to confirm`}
                  className="w-full"
                />
              </div>
            )}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>{cancelLabel}</AlertDialogCancel>
          <AlertDialogAction 
            onClick={handleConfirm}
            disabled={isConfirmDisabled}
            className="bg-destructive text-destructive-foreground hover:bg-destructive/90 disabled:opacity-50"
          >
            {confirmLabel}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  )
}

export { ConfirmationDialog }
export type { ConfirmationDialogProps }